import { render, staticRenderFns } from "./CardAulaTopicoLista.vue?vue&type=template&id=488068f5&scoped=true&"
import script from "./CardAulaTopicoLista.vue?vue&type=script&lang=js&"
export * from "./CardAulaTopicoLista.vue?vue&type=script&lang=js&"
import style0 from "./CardAulaTopicoLista.vue?vue&type=style&index=0&id=488068f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488068f5",
  null
  
)

export default component.exports